import { Select } from "antd";
import styled from "styled-components";

export const ButtonsWrapper = styled.div`
    padding-top: 16px;
    margin-top: auto;
`;

export const StyledMainContent = styled.div`
    overflow-y: auto;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const StyledDebtDropdown = styled.div`
    .ant-select-item-option-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
`;

export const StyledDebtDropdownHeader = styled(Select)`
    .ant-select-selector {
        height: 46px;
    }

    .ant-select-selection-item {
        height: auto !important;
    }

    .ant-select-selection-placeholder {
        font-size: 16px;
    }

    .ant-select-selection-wrap {
        height: 100%;
    }
`;
